var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoriteOnWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8-7h40v40H-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.91 19.886l-6.217 3.268c-.979.515-1.62.047-1.434-1.042l1.187-6.921-5.028-4.902c-.792-.772-.546-1.527.548-1.686l6.949-1.01 3.108-6.297c.49-.992 1.284-.99 1.773 0l3.107 6.297 6.95 1.01c1.094.16 1.339.915.547 1.686l-5.028 4.902 1.187 6.921c.187 1.09-.457 1.556-1.434 1.042l-6.216-3.268z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOnWhite);
export default __webpack_public_path__ + "static/media/favorite-on-white.8c49d397.svg";
export { ForwardRef as ReactComponent };